import {Divider, Space, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const CincoM = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Validation</Paragraph>
        <Space size={80} align="center" style={{background: 'inherit', width: 'fit-content', marginTop: '-2%', textAlign: 'center'}}>
          <Content style={{float: 'left', background: 'inherit', marginTop: '6%'}}>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh'}}>Itzel Coquis Rioja</Paragraph>
            <Text className='BaseText5'>She began her professional career at Coca Cola Femsa. Later, in the area of market intelligence at Kantar Millward Brown as Account Coordinator. Today she is the Director of Marketing  at Tec de Monterrey, CCM. Since 2017 she has been a professor at the Business School.</Text>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh', textAlign: 'center'}}>Knowledge</Paragraph>
            <Text className='BaseText5'>
              <ul>
                <li>What is marketing?</li>
                <li>Who are our main consumers?</li>
                <li>How to do an advertising campaign?</li>
                <li>Calculate our market size</li>
                <li>How to do a competitor analysis?</li>
                <li>Create our marketing and advertising strategy</li>
              </ul>
            </Text>
          </Content>
          <Content style={{width: 'fit-content', display: 'block', marginTop: '3%', background: 'transparent'}}>
            <Image width="150%" src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-57.jpeg'/>
          </Content>
        </Space>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default CincoM;
